import React from 'react';
import Bootstrap, { Scripts } from '../bootstrap';
import MicroComponent from '../common/MicroComponent';
import StayLocationFactory from '../../pactum-server/stubs/StayLocationFactory';
import dayjs from 'dayjs';

const ProductPage: React.FC = () => {
  const args = {
    content: { destination: StayLocationFactory(), destinationContent: false },
    selectedStay: '4005620',
    onAction: (data) => alert(JSON.stringify(data)),
    startDate: dayjs().add(1, 'month').format('YYYY-MM-DD'),
    nights: 4,
    travellers: {
      adult: 2,
    },
    queryParams: { startDate: dayjs().add(1, 'month').format('YYYY-MM-DD'), nights: '2', adults: '2', origin: 'SYD' },
  };

  return (
    <Bootstrap scripts={[Scripts.Flights, Scripts.Maps, Scripts.Search]}>
      <MicroComponent micro={{ sdkName: SERVICE_SDK_NAME, componentName: 'ResultsPage' }} {...args} />
    </Bootstrap>
  );
};

export default ProductPage;
